import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query"

import { setAppConfig } from "../redux/slices/configSlice";

import { getAppConfig } from "../services/config";
import { useEffect } from "react";

export const useFetchAppConfig = () => {
  const dispatch = useDispatch();
  const loadedAppConfig = useSelector((state) => state.config.loaded);

  const { data: fetchedConfig, isFetching } = useQuery({
    queryKey: ['config'],
    queryFn: () => getAppConfig(),
    staleTime: 1_000 * 60 * 60 * 24, // 24 hours in ms
  });

  useEffect(() => {
    if (!loadedAppConfig && !isFetching && fetchedConfig) {
      dispatch(setAppConfig(fetchedConfig));
    }
  }, [loadedAppConfig, isFetching, fetchedConfig, dispatch]);
}
